// 计算初始余额和各条目的余额变化
const calculateBalances = (list, finalBalance) => {
  // 计算所有交易的总和
  const totalChange = list.reduce((sum, item) => {
    return sum + (item.type === 'income' ? item.amount : -item.amount);
  }, 0);
  
  // 计算初始余额
  const initialBalance = finalBalance - totalChange;
  
  // 从后向前计算每条记录后的余额
  let currentBalance = initialBalance;
  const updatedList = [...list].map(item => {
    // 深拷贝对象
    const newItem = { ...item };
    
    // 添加创建时间
    const randomHour = Math.floor(Math.random() * 24);
    const randomMinute = Math.floor(Math.random() * 60);
    const randomSecond = Math.floor(Math.random() * 60);
    const timeStr = `${randomHour.toString().padStart(2, '0')}:${randomMinute.toString().padStart(2, '0')}:${randomSecond.toString().padStart(2, '0')}`;
    
    // 从expireTime中提取日期部分，添加随机时间
    const datePart = newItem.expireTime.split('-');
    const createDate = `${datePart[0]}-${Math.max(1, parseInt(datePart[1]) - 3).toString().padStart(2, '0')}-${Math.floor(Math.random() * 28 + 1).toString().padStart(2, '0')}`;
    newItem.createTime = `${createDate} ${timeStr}`;
    
    // 计算该交易后的余额
    currentBalance += (newItem.type === 'income' ? newItem.amount : -newItem.amount);
    newItem.balanceAfter = currentBalance;
    
    return newItem;
  });
  
  return updatedList;
};

// 计算总收入和总支出
const calculateTotals = (list) => {
  return list.reduce((totals, item) => {
    if (item.type === 'income') {
      totals.totalIncome += item.amount;
    } else {
      totals.totalExpense += item.amount;
    }
    return totals;
  }, { totalIncome: 0, totalExpense: 0 });
};

// 原始交易列表
const transactionList = [
  {
    detail: '邀请好友奖励',
    amount: 100,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '购买AI服务',
    amount: 50,
    type: 'expense',
    expireTime: '2025-07-15'
  },
  {
    detail: '每日签到奖励',
    amount: 10,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: 'AI绘画服务',
    amount: 30,
    type: 'expense',
    expireTime: '2025-08-20'
  },
  {
    detail: '任务完成奖励',
    amount: 20,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '高级会员赠送',
    amount: 200,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '使用AI翻译服务',
    amount: 15,
    type: 'expense',
    expireTime: '2025-09-10'
  },
  {
    detail: '分享内容奖励',
    amount: 30,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '购买高级模型使用权',
    amount: 80,
    type: 'expense',
    expireTime: '2025-10-05'
  },
  {
    detail: '参与活动奖励',
    amount: 50,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '使用AI写作助手',
    amount: 25,
    type: 'expense',
    expireTime: '2025-08-30'
  },
  {
    detail: '推荐新用户奖励',
    amount: 60,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '购买数据分析服务',
    amount: 45,
    type: 'expense',
    expireTime: '2025-09-25'
  },
  {
    detail: '系统赠送',
    amount: 15,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '使用AI视频生成',
    amount: 70,
    type: 'expense',
    expireTime: '2025-11-15'
  },
  {
    detail: '完成新手任务',
    amount: 25,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '购买高级存储空间',
    amount: 40,
    type: 'expense',
    expireTime: '2025-10-20'
  },
  {
    detail: '社区贡献奖励',
    amount: 35,
    type: 'income',
    expireTime: '2025-12-31'
  },
  {
    detail: '使用AI语音转文字',
    amount: 20,
    type: 'expense',
    expireTime: '2025-09-15'
  },
  {
    detail: '季度活跃用户奖励',
    amount: 75,
    type: 'income',
    expireTime: '2025-12-31'
  }
];

// 当前余额
const currentBalance = 350;

// 处理数据
const processedList = calculateBalances(transactionList, currentBalance);
const { totalIncome, totalExpense } = calculateTotals(transactionList);

export const mockNamiDetails = {
  list: processedList,
  total: processedList.length,
  balance: currentBalance,
  totalIncome,
  totalExpense
};
